module.exports = __webpack_public_path__ + "static/media/kata_screenshot.f09b359e.webp";